import type { ReactElement } from 'react';

import { ComingSoon } from '@config/components';

export const AuditLogPage = (): ReactElement => <ComingSoon sectionKey="auditLog" />;
